import type { WithdrawalDTO } from './types/withdrawals.types';

export function formatWithdrawalAmount(item: Pick<WithdrawalDTO, 'amount_minor' | 'amount_fen' | 'market_id' | 'currency' | 'currency_exponent' | 'currency_symbol'>): string {
  const vietnam = item.currency === 'VND' || item.market_id === 'VN';
  const exponent = item.currency_exponent ?? (vietnam ? 0 : 2);
  const amount = (item.amount_minor ?? item.amount_fen) / 10 ** exponent;
  const text = amount.toLocaleString('en-US', { minimumFractionDigits: exponent, maximumFractionDigits: exponent });
  const symbol = item.currency_symbol || (vietnam ? '₫' : '¥');
  return vietnam ? `${text} ${symbol}` : `${symbol}${text}`;
}
